import * as React from 'react';
import { compKey } from './key';
import { namespacedClassnames } from '../../common';
import { Label, Text } from '../../new-libby/core';
var getRangeSize = function (min, max, rangesCount) { return Math.round((max - min) / rangesCount); };
var getColorRanges = function (colors, min, max) {
    var rangeSize = getRangeSize(min, max, colors.length);
    return colors.map(function (color, idx) { return ({
        from: !idx ? min : min + (rangeSize * idx) + 1,
        to: min + rangeSize * (idx + 1),
        color: color
    }); });
};
var findRange = function (colorRanges, value) {
    return colorRanges.find(function (colorRange) { return colorRange.from <= value && colorRange.to >= value; }) || null;
};
var getLabelColor = function (colors, rangeMin, rangeMax, value) {
    var colorRanges = getColorRanges(colors, rangeMin, rangeMax);
    var valueRange = findRange(colorRanges, value);
    return valueRange === null || valueRange === void 0 ? void 0 : valueRange.color;
};
var logValidationWarning = function () {
    console.warn('Props are not valid! Range size for one color must be >=1 and value must be between min and max');
    return null;
};
export var RangeLabel = function (props) {
    var min = props.min, max = props.max, colors = props.colors, value = props.value;
    var classNames = namespacedClassnames(compKey, props.className);
    var isRangeSizeValid = getRangeSize(min, max, colors.length) >= 1;
    var labelColor = getLabelColor(colors, min, max, value);
    return labelColor && isRangeSizeValid ? (React.createElement("div", { className: classNames },
        React.createElement(Label, { color: labelColor, size: 'tiny', borderless: true },
            React.createElement(Text, { className: 'range-value-container' }, props.value)))) : logValidationWarning();
};
//# sourceMappingURL=index.js.map